export const PLAN_IDS = {
  UNLIMITED: 'SM_UNLIMITED',
  DATA_ONLY_UNLIMITED: 'SM_UNLIMITED_DATAONLY',
  ST_UNLIMITED: 'SM_ST_UNLIMITED',
  SM_FOUR_GB_PLAN: 'SM_4GB_NDD',
  FAMILY_GROUP: 'SM_EVERYONE_UNLIMITED',
  FAMILY_GROUP_MEMBER: 'SM_EVERYONE_UNLIMITED_MEMBER',
}
